import { render, staticRenderFns } from "./RoosterEditorBase.vue?vue&type=template&id=145f78bc&scoped=true&"
import script from "./RoosterEditorBase.vue?vue&type=script&lang=js&"
export * from "./RoosterEditorBase.vue?vue&type=script&lang=js&"
import style0 from "./RoosterEditorBase.vue?vue&type=style&index=0&id=145f78bc&prod&scoped=true&lang=css&"
import style1 from "./RoosterEditorBase.vue?vue&type=style&index=1&id=145f78bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f78bc",
  null
  
)

export default component.exports